import React from "react";

export default function ErrorMessageWrapper({ title }) {
  return <p className="error_message">{title}</p>;
}
